import { useZoomContext } from '../../../../context/ZoomContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback } from 'react'
import { MediaBtnContainer } from '../../../pre-meeting/components/Buttons'
import { Tip } from '../../../../components/Tip'
import { useTranslation } from 'react-i18next'
import { useHRExpertMentors } from '../../../../hooks/useHRExpertMentors'

export const Participants = (props: ChatIconProps) => {
    const { t } = useTranslation('meeting')
    const { sidebarMode, setSidebarMode } = useZoomContext()
    const { showHRPanel } = useHRExpertMentors()

    const onToggleSidebar = useCallback(() => {
        setSidebarMode(oldSidebarMode => {
            // If can attend help request, use help-request mode
            const targetMode = showHRPanel ? 'help-request' : 'participants'
            return oldSidebarMode === targetMode ? null : targetMode
        })
    }, [setSidebarMode, showHRPanel])

    return (
        <div>
            <MediaBtnContainer
                active={sidebarMode === (showHRPanel ? 'help-request' : 'participants')}
                square
                onClick={e => {
                    e.stopPropagation()
                    onToggleSidebar()
                }}
                data-tooltip-id="participants-pre-action"
            >
                <FontAwesomeIcon icon={['far', 'users']} fixedWidth />
            </MediaBtnContainer>
            <Tip
                id="participants-pre-action"
                content={
                    sidebarMode === (showHRPanel ? 'help-request' : 'participants')
                        ? showHRPanel
                            ? t('participants.hideHelpRequests', 'Hide Help Requests')
                            : t('participants.hideParticipants')
                        : showHRPanel
                        ? t('participants.showHelpRequests', 'Show Help Requests')
                        : t('participants.showParticipants')
                }
            />
        </div>
    )
}

interface ChatIconProps extends React.HTMLAttributes<HTMLButtonElement> {}
